import { render, staticRenderFns } from "./OnboardingComponent.vue?vue&type=template&id=9e9f03ce&scoped=true"
import script from "./OnboardingComponent.vue?vue&type=script&lang=js"
export * from "./OnboardingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9f03ce",
  null
  
)

export default component.exports